import { constructFrom as a } from "./constructFrom.js";
import { toDate as i } from "./toDate.js";
function s(e, r, o) {
  const t = i(e, o?.in);
  return isNaN(r) ? a(e, NaN) : (r && t.setDate(t.getDate() + r), t);
}
export {
  s as addDays,
  s as default
};
